import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";

import ViewPostModal from "../ViewPostModal";
import { getSibilingPosts } from "@redux/postsBySubscription/actions";

const ViewPostBySubscriptionModal = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const { isGettingSibilings } = useSelector(
    ({ postsBySubscriptionReducer }) => postsBySubscriptionReducer,
  );

  const subId = searchParams.get("subId");
  const postId = searchParams.get("postId");
  const postBySub = searchParams.get("postBySub");
  const offset = searchParams.get("o");

  const hasData = subId && postId;

  useEffect(() => {
    if (subId)
      dispatch(
        getSibilingPosts({
          offset,
          subscription: subId,
        }),
      );
  }, [dispatch, offset, subId]);

  return (
    hasData && (
      <ViewPostModal
        withArrows
        postKey={postBySub}
        arrowsDisabled={isGettingSibilings}
      />
    )
  );
};

export default ViewPostBySubscriptionModal;
